export * from './progress.module';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
